<!-- 
カード形式のダイアログ（背景無し）の共通画面部品
@props
  title : カードの上部に表示するタイトル文字列
  elevation : カードにつける陰の量の大きさ、未定義なら2とする
@slot
  カード内に表示するコンテンツ
-->

<template>
  <v-card
    max-width="700"
    :min-width="cardMinWidth"
    color="grey lighten-2"
    :elevation="elevationValue"
  >
    <v-card-text class="font-weight-medium">{{ title }}</v-card-text>
    <v-card color="white" class="pb-4">
      <slot></slot>
    </v-card>
  </v-card>
</template>

<script>
import ValueMapper from "../../logic/common/value-mapper";
export default {
  props: ["title", "elevation"],
  computed: {
    cardMinWidth() {
      const mobileMinWidth = 360;
      const minWidth = 700;
      return ValueMapper.map({
        xs: mobileMinWidth,
        sm: mobileMinWidth,
      }).getOrElse(this.$vuetify.breakpoint.name, minWidth);
    },
    elevationValue() {
      if (this.elevation == undefined) {
        return "2";
      }
      return this.elevation;
    },
  },
};
</script>

<style></style>
